import { Box, HStack, IconButton } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { theme } from 'styles/configure-theme';

export const StyledButtonBox = Box.withConfig({
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  alignContent: 'center',
});

export const StyledRecentOrderCard = HStack.withConfig({
  borderBottomWidth: '1px',
  borderBottomColor: Styles.color.white,
  justifyContent: 'space-between',
  backgroundColor: Styles.color.cardBackground,
  paddingY: '$5',
  paddingX: '$4',
});

export const StyledActionButton = ActionButton;

export const AddIconButton = IconButton.withConfig<{
  disabled?: boolean;
}>(p => ({
  padding: 0,
  borderColor: p.disabled ? theme.token('icon-disabled') : theme.token('increment-active'),
  _icon: {
    color: p.disabled ? theme.token('text-disabled') : theme.token('increment-active'),
  },
}));
